import { module as Module } from 'modujs'
import gsap from 'gsap'
import { html } from '../utils/environment'

export default class extends Module {
  /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */

  constructor(m) {
    super(m)

    // UI
    this.$player = this.$('player')[0]
    this.$video = this.$('video')[0]

    this.events = {
      click: {
        close: 'close',
      },
    }

    // Data
    this.videoSrc = null

    // Binding
    this.onVideoEndedBind = this.onVideoEnded.bind(this)
    this.onTransitionEndBind = this.onTransitionEnd.bind(this)

    // Timeline
    this.timeline = gsap.timeline({ paused: true })
      .set(this.el, { display: 'block' })
      .to(this.el, { autoAlpha: 1, duration: 0.4, ease: 'linear' })
  }

  /// ////////////
  // Callbacks
  /// ////////////
  onInit() {
    this.videoPlayerID = this.$player.dataset.moduleVideoPlayer
    window.addEventListener('videoPlayerEnded', this.onVideoEndedBind)
    this.el.addEventListener('transitionend', this.onTransitionEndBind)
  }

  onVideoEnded() {
    this.close()
  }

  onTransitionEnd(e) {
    const property = e.propertyName

    if (property != 'visibility' || this.isOpen) return

    requestAnimationFrame(() => {
      this.call('pause', this.videoPlayerID, 'VideoPlayer')
      this.call('reset', this.videoPlayerID, 'VideoPlayer')
    })
  }

  open(args) {
    // Get video src
    let videoSrc = null
    let videoPoster = null

    videoSrc = args.src
    videoPoster = args.poster

    // If no video
    if (videoSrc == null) return

    if (videoSrc != this.videoSrc) {
      // Set video & poster src
      this.$video.src = videoSrc
      this.$video.poster = videoPoster

      // Store video & poster src
      this.videoSrc = videoSrc
      this.videoPoster = videoPoster
    }

    this.timeline.play()

    html.classList.add('has-modal-video-open')

    // Play video
    this.call('play', this.videoPlayerID, 'VideoPlayer')

    // Unmute video
    this.call('progressiveUnmute', this.videoPlayerID, 'VideoPlayer')
  }

  close() {
    this.timeline.reverse()
    this.call('progressiveMute', this.videoPlayerID, 'VideoPlayer')
    this.call('pause', this.videoPlayerID, 'VideoPlayer')
    this.call('reset', this.videoPlayerID, 'VideoPlayer')
    html.classList.remove('has-modal-video-open')
  }
}
